import { P3 } from '@repo/ui/components/Typography';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const Remix = styled(P3)`
  margin-top: 10px;
  color: ${themeStyle.varInkMedium};

  a {
    color: ${themeStyle.varInkMedium};
  }
`;
